// Obfuscated admin route prefix to prevent automated attacks
// Change this value to rotate the admin URL
const ADMIN_PREFIX = "/cx9m3k";

export const ADMIN_ROUTES = {
  login: `${ADMIN_PREFIX}/login`,
  dashboard: `${ADMIN_PREFIX}/dashboard`,
  users: `${ADMIN_PREFIX}/users`,
  userDetail: `${ADMIN_PREFIX}/users/:userId`,
  payments: `${ADMIN_PREFIX}/payments`,
  invoices: `${ADMIN_PREFIX}/invoices`,
  messages: `${ADMIN_PREFIX}/messages`,
  config: `${ADMIN_PREFIX}/config`,
  paymentConfig: `${ADMIN_PREFIX}/payment-config`,
  security: `${ADMIN_PREFIX}/security`,
  officialAids: `${ADMIN_PREFIX}/official-aids`,
  demoAccount: `${ADMIN_PREFIX}/demo-account`,
  profitability: `${ADMIN_PREFIX}/profitability`,
  cache: `${ADMIN_PREFIX}/cache`,
  seoAudit: `${ADMIN_PREFIX}/seo-audit`,
  seoOptimization: `${ADMIN_PREFIX}/seo-optimization`,
  jobs: `${ADMIN_PREFIX}/jobs`,
  xPosts: `${ADMIN_PREFIX}/x-posts`,
} as const;
